document.addEventListener('turbo:load', () => {
  const element = document.querySelector('[data-behavior="free-consultation-hint"]')

  if (!element || element.hasAttribute('data-hint-shown')) {
    return
  }

  element.setAttribute('data-hint-shown', 'true')

  dataConfirmModal.confirm({
    title: element.dataset.title,
    text: element.dataset.text,
    commit: element.dataset.commit,
    commitClass: 'btn-primary',
    cancel: '',
    cancelClass: 'd-none',
    onConfirm: () => {
      const token = document.querySelector('meta[name="csrf-token"]')

      fetch(element.dataset.url, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: {
          'X-CSRF-Token': token ? token.content : '',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
    }
  })
})
